import { useEffect, useRef } from 'react';
import { useTracker } from '../../state/store';
import { audioEngine } from '../../engine/audio';
import { Button, Panel } from './primitives';

export function InstrumentList() {
  const song = useTracker((s) => s.song);
  const currentInstrument = useTracker((s) => s.currentInstrument);
  const revision = useTracker((s) => s.revision);
  const setCurrentInstrument = useTracker((s) => s.setCurrentInstrument);
  const addInstrument = useTracker((s) => s.addInstrument);
  const activeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({ block: 'nearest' });
  }, [currentInstrument]);

  return (
    <Panel
      title="Instruments"
      dense
      actions={
        <Button onClick={addInstrument} title="Append an empty instrument">
          +
        </Button>
      }
    >
      <div className="h-full overflow-y-auto px-1.5 py-1.5" key={revision}>
        {song.instruments.map((inst, i) => {
          const index = i + 1;
          const active = index === currentInstrument;
          const empty = inst.samples.length === 0 || inst.samples[0].length === 0;
          return (
            <button
              key={i}
              ref={active ? activeRef : undefined}
              type="button"
              onClick={() => setCurrentInstrument(index)}
              onDoubleClick={() => audioEngine.noteOn(7, 49, index)}
              title={empty ? 'Empty instrument' : 'Double-click to preview at C-4'}
              className={`flex w-full items-center gap-2 rounded px-2 py-[3px] text-left font-mono text-[11px] transition-colors ${
                active
                  ? 'bg-acid-900 text-acid-300 ring-1 ring-acid-600'
                  : 'text-ink-400 hover:bg-ink-800 hover:text-white'
              }`}
            >
              <span className="w-5 shrink-0 text-ink-500">
                {index.toString(16).toUpperCase().padStart(2, '0')}
              </span>
              <span className={`truncate ${empty ? 'italic text-ink-600' : ''}`}>
                {inst.name || (empty ? '—' : '(unnamed)')}
              </span>
            </button>
          );
        })}
      </div>
    </Panel>
  );
}
